import { userConstants, alertConstants } from '../_constants'

const initialState = {
  isLoading: false,
  userList: [],
  error: null,
  isGetAllError: false,
  count: 0,
  userEntry: '',
  settingsEntry: '',
  addUserMessage: null,
  updateUserMessage: null,
  activeData: {},
  backOfficeMessage: null,
  justLookingEntry:null,
  maptoolxMessage:null,
  isLogout: false
}
export function users(state = { ...initialState }, action) {
  state = {
    ...state,
    userEntry:'',
  }
  switch (action.type) {
  case alertConstants.CLEAR:
    return {
      ...state,
      activeData: {},
      userEntry: null,
      maptoolxMessage:null,
      backOfficeMessage:null,
      updateUserMessage:null,
      addUserMessage:null
    }
  case userConstants.RESET_PASSWORD_REQUEST:
    return {
      ...state,
      isLoading: true,
      resetPasswordSuccess: null,
      resetPasswordError: null,

    }
  case userConstants.RESET_PASSWORD_SUCCESS:
    return {
      ...state,
      isLoading: false,
      resetPasswordSuccess: action.user
    }
  case userConstants.RESET_PASSWORD_FAILURE:
    return {
      ...state,
      isLoading: false,
      resetPasswordError: action.error
    }
  case userConstants.FORGET_PASSWORD_REQUEST:
    return {
      loading: true
    }
  case userConstants.FORGET_PASSWORD_SUCCESS:
    return {
      forgotPasswordSuccess: action.users
    }
  case userConstants.FORGET_PASSWORD_FAILURE:
    return {
      forgotPasswordError: action.error
    }
  case userConstants.GETALL_PAGE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addUserMessage: null
    }
  case userConstants.GETALL_PAGE_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      userList: [],
      count: 0,
      isGetAllError: true,
      addUserMessage: null
    }
  case userConstants.GETALL_PAGE_SUCCESS:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      addUserMessage: null,
      userList: action.users.data,
      count: action.users.count
    }
  case userConstants.DELETE_REQUEST:
    // add 'deleting:true' property to user being deleted
    return {
      ...state,
      items: state.items.map(user =>
        user.id === action.id
          ? { ...user, deleting: true }
          : user
      )
    }
  case userConstants.DELETE_SUCCESS:
    // remove deleted user from state
    return {
      items: state.items.filter(user => user.id !== action.id)
    }
  case userConstants.DELETE_FAILURE:
    // remove 'deleting:true' property and add 'deleteError:[error]' property to user
    return {
      ...state,
      items: state.items.map(user => {
        if (user.id === action.id) {
          // make copy of user without 'deleting:true' property
          const { deleting, ...userCopy } = user
          // return copy of user with 'deleteError:[error]' property
          return { ...userCopy, deleteError: action.error }
        }

        return user
      })
    }
  case userConstants.ACTIVE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addUserMessage: null
    }
  case userConstants.ACTIVE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      activeData: action.response,
      addUserMessage: null
    }
  case userConstants.ACTIVE_FAILURE:
    return {
      ...state,
      isLoading: false,
      addUserMessage: null
    }
  case userConstants.ADD_REQUEST:
    return {
      loading: true,
      addUserMessage: null
    }
  case userConstants.ADD_SUCCESS:
    return {
      addUserMessage: action.user.message,
      isLoading: false,
    }


  case userConstants.GETBYID_SUCCESS:
    if(action.isUser){
      return {
        ...state,
        userEntry: action.user,
        updateUserMessage: null,
        isLoading: true,
        addUserMessage: null
      }
    }else{
      return {
        ...state,
        settingsEntry: action.user,
        updateUserMessage: null,
        isLoading: true,
        addUserMessage: null
      }}
  case userConstants.GETBYID_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      addUserMessage: null,
      updateUserMessage: null
    }
  case userConstants.GETBYID_REQUEST:
    if(action.isUser){
      return {
        ...state,
        userEntry: action.user,
        updateUserMessage: null,
        isLoading: true,
        addUserMessage: null
      }
    }else{
      return {
        ...state,
        settingsEntry: action.user,
        updateUserMessage: null,
        isLoading: true,
        addUserMessage: null
      }
    }
  case userConstants.UPDATE_REQUEST:
    return {
      loading: true,
      updateUserMessage: null
    }
  case userConstants.UPDATE_SUCCESS:
    return {
      updateUserMessage: action.user.message,
      isLoading: false,
    }
  case userConstants.BACKOFFICE_REQUEST:
    return {
      isLoading: true,
      backOfficeMessage: action.user.message
    }
  case userConstants.BACKOFFICE_SUCCESS:
    return {
      backOfficeMessage: action.user.message,
      isLoading: false,
    }

  case userConstants.GETBYID_JUSTLOOKING_SUCCESS:
    return {
      ...state,
      justLookingEntry: action.user,
      isLoading: false,
    }
  case userConstants.GETBYID_JUSTLOOKING_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      justLookingEntry: null,
    }
  case userConstants.GETBYID_JUSTLOOKING_REQUEST:
    return {
      ...state,
      isLoading: true,
      justLookingEntry: action.user
    }

  case userConstants.MAPTOOLX_REQUEST:
    return {
      isLoading: true,
      maptoolxMessage: null
    }
  case userConstants.MAPTOOLX_SUCCESS:
    return {
      maptoolxMessage: action.user.message,
      isLoading: false,
    }
    case userConstants.LOGOUT_SESSION: 
    return {
      ...state,
      isLogout:action.isLogout
    }
  default:
    return state
  }
}
